import {DeliveryCalculateGenqlSelection} from "@/gql/gen";

export const DeliveryCalculateFields: DeliveryCalculateGenqlSelection = {
    ID: true,
    ADDRESS_COORDS: true,
    DELIVERY_ADDRESS: true,
    DELIVERY_HASH: true,
    NEED_TIME: true,
    ORDER_ID: true,
    ORDER_PRICE: true,
    PHONE: true,
    REQUEST_DELTA: true,
    REQUEST_TIME: true,
    RES_DELIVER_PRICE: true,
    RES_OFFICE_1C_ID: true,
    RES_OFFICE_ID: true,
    RES_STATUS: true,
    RES_TIME: true,
    RES_TIME_FORMATTED: true,
    TIME_MODE: true,
    TRANSPORT_TYPE: true,
    VORDER_ID: true,
}
